/* mo-lineup-molecule.js: the Molecule look of sections/mo-brand-lineup.liquid (2026-10-06).
 * Loaded only when the section's Look is "Molecule", before assets/mo-brand-lineup.js. Three parts:
 *   boot                    puts the look class and data-draw on the lineup root, so the shared
 *                           root line in the section needs no edit
 *   MOLineupHeroes.airflow  the showpiece: Molecule's photo of the bed and, under it, the bed cut
 *                           open with air moving through the layers Molecule says pass air
 *   MOLineupDraw.molecule   the row drawings: the same cut, small, one per row
 * No libraries. */
(function () {
  'use strict';
  function mark(scope) {
    /* every lineup root on the page: this file loads only when the Look is Molecule, and the rows
       need their drawings and styles even when the showpiece is switched off */
    var roots = (scope || document).querySelectorAll('[data-mo-lineup]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!root.classList.contains('mo-lineup--molecule')) root.classList.add('mo-lineup--molecule');
      if (root.getAttribute('data-draw') !== 'molecule') root.setAttribute('data-draw', 'molecule');
    }
  }
  mark(document);
  /* the theme editor re-renders a section; mark it before the shared script boots it again */
  document.addEventListener('shopify:section:load', function (e) { mark(e.target); }, true);
})();

/* ---------- MOLineupHeroes.airflow ----------
 * The showpiece of the Molecule lineup. Molecule's photo of the bed sits in the top of the stage
 * (plain markup). This script draws the same bed cut through the middle in the lower part, its
 * layers in Molecule's order at the bed's true height, and moves air through it as particles in a
 * flow field. Air moves only through the layers Molecule says pass air (kinds open, zoned, vent,
 * airtec, airtec-channel, base-air); covers and the LiftCOR layer are walls, and no particle ever
 * enters them. The pointer is a warm body on the bed: air near it warms, and the flow carries it out
 * through the sides while cool air comes in low. A stepper switches the model.
 *
 * The field inside an air layer is the curl of a stream function, so the layer has no sources or
 * sinks and its top and bottom are walls. With v the depth through the layer (0 top, 1 bottom):
 *   psi = e t [ U (v - sin(2 pi v) / 2 pi) + B Q sin^2(pi v) tanh((x - xb) / w) ]
 * e is the layer's ease, t its thickness, U the idle drift, B the body's weight (0 to 1) at xb.
 * The body term draws air in along the lower half, lifts it under the body and sends it out along
 * the upper half. Outside the bed a particle is exhaust: it keeps its exit speed, rises if warm,
 * and thins out.
 *
 * Particles are comets (after "Aether Vortex" by daiwiikharihar, 21st.dev id 25772): each keeps its
 * last few positions and is drawn head to tail, thinner and fainter toward the tail. The still
 * (reduced motion, Save-Data, the poster) is the same simulation run with the trails left to
 * build up into flow lines (after "Flow Field Background" by jahed, 21st.dev id 9962).
 * It shows the idea, not a measurement; the page says so. Nothing is written to the page from the
 * frame loop. */
(function () {
  'use strict';
  if (window.MOLineupMoleculeAir) return;
  window.MOLineupMoleculeAir = true;

  var heroes = window.MOLineupHeroes = window.MOLineupHeroes || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saver = !!(navigator.connection && navigator.connection.saveData);
  var TAU = Math.PI * 2;

  /* air: ease of flow (0 is a wall). w: illustrative depth weight in inches (Molecule publishes
     no layer depths). cell: drawn cell size in inches. */
  var KIND = {
    'cover': { air: 0, w: 0.4 },
    'open': { air: 0.6, w: 2.5, cell: 0.42 },
    'zoned': { air: 0.5, w: 3, cell: 0.36, top: 'wave' },
    'vent': { air: 0.85, w: 2, cell: 0.56 },
    'airtec': { air: 1, w: 2.5, cell: 0.62 },
    'airtec-channel': { air: 1, w: 2.5, cell: 0.62, top: 'crate' },
    'base-air': { air: 0.2, w: 0, cell: 0.2, base: true },
    'lift': { air: 0, w: 3, bands: true },
    'base': { air: 0, w: 0, base: true }
  };
  var PLAIN = { air: 0, w: 2 };
  var TAIL = 6;                                   /* positions kept per particle */
  var TAIL_A = [1, 0.72, 0.5, 0.32, 0.18];        /* opacity of each tail segment, head first */

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function mix(a, b, t) { return a + (b - a) * t; }
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('en-US'); }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function setHidden(el, on) { if (el && el.hidden !== on) el.hidden = on; }
  /* a small seeded generator, so a still is the same on every load */
  function rng(seed) { var s = seed >>> 0 || 1; return function () { s = (s + 0x6D2B79F5) >>> 0; var t = Math.imul(s ^ (s >>> 15), 1 | s); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }

  /* colors: parsed by a detached canvas, so any CSS color works and nothing touches the page */
  var probe = null;
  function rgb(value, fallback) {
    value = (value || '').trim();
    if (!value) return fallback;
    if (!probe) probe = document.createElement('canvas').getContext('2d');
    if (!probe) return fallback;
    probe.fillStyle = '#010203'; probe.fillStyle = value;
    var s = probe.fillStyle, m;
    if (s === '#010203' && value.toLowerCase() !== '#010203') return fallback;
    if (s.charAt(0) === '#') return [parseInt(s.substr(1, 2), 16), parseInt(s.substr(3, 2), 16), parseInt(s.substr(5, 2), 16)];
    if ((m = /rgba?\(([^)]+)\)/.exec(s))) { var p = m[1].split(',').map(parseFloat); return [p[0], p[1], p[2]]; }
    return fallback;
  }
  function css(c, a) { return 'rgba(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ',' + (a == null ? 1 : a) + ')'; }
  function blend(a, b, t) { return [mix(a[0], b[0], t), mix(a[1], b[1], t), mix(a[2], b[2], t)]; }

  /* "Label | kind" lines to layers with a depth in inches. A depth in the label (2 in.) wins;
     the rest share the height by weight, and the base takes what is left (30% at least). */
  function parseLayers(text, height) {
    var out = [];
    String(text || '').split('\n').forEach(function (line) {
      var bits = line.split('|'), label = (bits[0] || '').trim(), kind = (bits[1] || '').trim().toLowerCase();
      if (!label) return;
      var k = KIND[kind] || PLAIN, m = /([\d.]+)\s*in\./.exec(label);
      out.push({ label: label, kind: kind, k: k, air: k.air, given: m ? parseFloat(m[1]) : 0 });
    });
    var fixed = 0, weights = 0, bases = 0;
    out.forEach(function (l) { if (l.given) fixed += l.given; else if (l.k.base) bases++; else weights += l.k.w; });
    var room = Math.max(0, height - fixed), forBase = bases ? Math.max(room * 0.3, room - weights) : 0;
    var scale = weights ? Math.min(1, (room - forBase) / weights) : 1;
    if (!bases && weights) scale = room / weights;
    out.forEach(function (l) { l.d = l.given || (l.k.base ? forBase / bases : l.k.w * scale); });
    return out;
  }

  heroes.airflow = function (root) {
    var hero = root.querySelector('[data-mo-lineup-hero][data-hero-style="airflow"]');
    var stage = hero && hero.querySelector('[data-airflow]');
    var box = stage && stage.querySelector('.mo-af__box');
    var bedC = stage && stage.querySelector('.mo-af__bed'), airC = stage && stage.querySelector('.mo-af__air');
    if (!box || !bedC || !airC || !bedC.getContext) return function () {};
    var bed = bedC.getContext('2d'), air = airC.getContext('2d');
    if (!bed || !air) return function () {};

    var models = [];
    try { models = JSON.parse(stage.querySelector('[data-af-models]').textContent) || []; } catch (e) { models = []; }
    models.forEach(function (m) { m.h = parseFloat(m.height) || 10; m.layers = parseLayers(m.layers, m.h); m.hasAir = m.layers.some(function (l) { return l.air > 0; }); });
    if (!models.length) return function () {};
    var tallest = Math.max.apply(null, models.map(function (m) { return m.h; }));

    var steps = Array.prototype.slice.call(stage.querySelectorAll('[data-af-step]'));
    var details = Array.prototype.slice.call(stage.querySelectorAll('[data-af-detail]'));
    var photos = Array.prototype.slice.call(stage.querySelectorAll('[data-af-photo]'));
    var statusEl = stage.querySelector('[data-af-status]');
    var lite = reduce || saver;
    var C = {}, tiles = {}, W = 0, H = 0, dpr = 1, G = null, rect = null;
    var cur = modelById(stage.getAttribute('data-model')) || models[0], from = null, morph = 1;
    var scene = null, oldBed = null, newBed = null;

    function modelById(id) { for (var i = 0; i < models.length; i++) if (models[i].id === id) return models[i]; return null; }

    function readColors() {
      var st = getComputedStyle(stage);
      ['cool', 'cool-hi', 'warm', 'hot', 'body', 'foam', 'foam-lo', 'cell', 'pore', 'comfort', 'dense', 'dense-lo', 'dense-cell', 'cover', 'knit', 'cover-cool', 'cool-line', 'gel', 'gel-hi', 'lift', 'edge', 'ink', 'ink2', 'floor', 'shadow', 'paper']
        .forEach(function (k) { C[k] = rgb(st.getPropertyValue('--af-' + k), C[k] || [128, 128, 128]); });
      C.dark = (C.paper[0] + C.paper[1] + C.paper[2]) < 300;
    }

    /* ---------- layout: the cut sits in the lower part of the box, under the photo ---------- */
    function layout() {
      var r = box.getBoundingClientRect();
      rect = r; W = r.width; H = r.height;
      if (!W || !H) { G = null; return; }
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      [bedC, airC].forEach(function (c) { var w = Math.round(W * dpr), h = Math.round(H * dpr); if (c.width !== w) c.width = w; if (c.height !== h) c.height = h; });
      var tall = W / H < 1.4, g = {};
      g.floor = H * 0.93;
      g.top = H * (tall ? 0.5 : 0.54) + 12;          /* the tallest bed's top surface */
      g.S = (g.floor - g.top) / tallest;              /* px per inch, the same for every model */
      g.mx = W * (tall ? 0.085 : 0.115);              /* room at each side for air to come and go */
      g.L = g.mx; g.R = W - g.mx;
      G = g;
    }
    function build(m) {
      var y = G.floor - m.h * G.S, layers = [], area = 0;
      m.layers.forEach(function (l, i) {
        var t = l.d * G.S, o = { i: i, kind: l.kind, k: l.k, air: l.air, y0: y, y1: y + t, t: t, cell: (l.k.cell || 0.4) * G.S };
        o.weight = l.air > 0 ? l.air * l.air * t + 0.02 * t : 0;
        area += o.weight; layers.push(o); y += t;
      });
      var acc = 0;
      layers.forEach(function (o) { acc += o.weight; o.cum = area ? acc / area : 0; });
      /* the body warms only the air it can reach: the air layers above the first solid layer under the cover */
      var warmTo = -1, blocked = false;
      layers.forEach(function (o) { if (blocked) return; if (o.air > 0) warmTo = o.i; else if (o.kind !== 'cover') blocked = true; });
      return { m: m, top: G.floor - m.h * G.S, layers: layers, airLayers: layers.filter(function (o) { return o.air > 0; }), hasAir: area > 0, warmTo: warmTo };
    }

    /* ---------- the bed (drawn when the model, the size or the colors change) ---------- */
    function tile(name, url) {
      if (saver || tiles[name]) return;
      var img = new Image();
      tiles[name] = { img: img, ok: false };
      img.onload = function () {
        tiles[name].ok = true;
        if (!G) return;
        /* the bed and the air are separate canvases: repaint the bed with its texture, and under
           reduced motion leave the air alone, so the still keeps its flow lines */
        drawBed(); if (!raf && !lite) drawAir();
      };
      img.src = url;
    }
    function pattern(ctx, name, scale) {
      var t = tiles[name];
      if (!t || !t.ok) return null;
      var p = ctx.createPattern(t.img, 'repeat');
      if (p && p.setTransform && window.DOMMatrix) p.setTransform(new DOMMatrix().scale(scale));
      return p;
    }
    function topEdge(o, x) {          /* the top surface of a contoured or convoluted layer */
      if (o.k.top === 'wave') return o.y0 + 2.2 + Math.sin((x - G.L) / (G.S * 1.15)) * 2.2;
      if (o.k.top === 'crate') return o.y0 + 3.2 - Math.abs(Math.sin((x - G.L) / (G.S * 0.62))) * 3.2;
      return o.y0;
    }
    function drawLayer(ctx, o, rand, last) {
      var x0 = G.L, x1 = G.R, x, k = o.k, yb = Math.min(o.y1 + (last ? 0 : 7), G.floor);
      /* foam colors follow Molecule's own layer renders and match the row drawings: pale blue CoolVENT, cream AirTEC, sea green under the gel bands, grey base */
      var foam = k.base ? C.dense : k.bands ? C.lift : o.kind === 'cover' ? C.cover : o.kind === 'open' ? C.comfort : o.kind === 'zoned' ? C['foam-lo'] : o.kind === 'vent' ? blend(C['cover-cool'], C.knit, 0.3) : C.foam;
      ctx.save();
      ctx.beginPath();
      /* each layer runs a little past its own bottom edge, under the next one, so a contoured top never leaves a gap */
      ctx.moveTo(x0, yb); ctx.lineTo(x0, topEdge(o, x0));
      for (x = x0; x <= x1; x += 3) ctx.lineTo(x, topEdge(o, x));
      ctx.lineTo(x1, topEdge(o, x1)); ctx.lineTo(x1, yb); ctx.closePath();
      ctx.fillStyle = css(foam); ctx.fill();
      ctx.clip();
      if (o.kind === 'cover') {
        /* a knit band: fine ticks */
        ctx.strokeStyle = css(C.knit, 0.9); ctx.lineWidth = 1;
        ctx.beginPath();
        for (x = x0 + 2; x < x1; x += 4) { ctx.moveTo(x, o.y0 + 1); ctx.lineTo(x + 2, o.y1 - 1); }
        ctx.stroke();
      } else {
        var pat = pattern(ctx, k.base ? 'dense' : 'open', k.base ? 0.5 : clamp(o.cell / 9, 0.28, 0.9));
        if (pat) { ctx.globalAlpha = k.base ? (C.dark ? 0.26 : 0.2) : (C.dark ? 0.34 : 0.24); ctx.globalCompositeOperation = 'multiply'; ctx.fillStyle = pat; ctx.fillRect(x0, o.y0 - 4, x1 - x0, o.t + 12); ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1; }
        /* drawn cells: open pores sized by kind; the base gets fine grain */
        var n = Math.round((x1 - x0) * o.t / (o.cell * o.cell) * (k.base ? 0.4 : 0.5)), i, cx, cy, r;
        n = Math.min(n, 2600);
        if (k.base) {
          ctx.fillStyle = css(C['dense-cell'], 0.42);
          for (i = 0; i < n; i++) { cx = mix(x0, x1, rand()); cy = mix(o.y0, o.y1, rand()); ctx.fillRect(cx, cy, 1.1, 1.1); }
        } else if (o.air > 0 || k.bands) {
          for (i = 0; i < n; i++) {
            cx = mix(x0, x1, rand()); cy = mix(o.y0 + 1, o.y1 - 1, rand()); r = o.cell * (0.26 + rand() * 0.3) * (k.bands ? 0.55 : 1);
            ctx.beginPath(); ctx.ellipse(cx, cy, r * 1.12, r * 0.9, rand() * 3, 0, TAU);
            ctx.fillStyle = css(C.paper, k.bands ? 0.28 : 0.5); ctx.fill();                          /* an open cell: lighter than the foam around it */
            ctx.strokeStyle = css(C.cell, k.bands ? 0.34 : 0.62); ctx.lineWidth = 0.7; ctx.stroke();
          }
        }
        if (k.bands) {
          /* gel bands under the sleeper's core: a row of blue bars across the middle of the cut */
          var a = mix(x0, x1, 0.2), b = mix(x0, x1, 0.8), count = Math.max(4, Math.round((b - a) / (G.S * 3.1))), w = (b - a) / count, bh = Math.min(o.t * 0.36, G.S * 1.05), by = o.y0 + o.t * 0.2;
          for (i = 0; i < count; i++) {
            var bx = a + w * i + w * 0.14, bw = w * 0.72, rr = bh / 2;
            ctx.beginPath(); ctx.moveTo(bx + rr, by); ctx.lineTo(bx + bw - rr, by); ctx.arc(bx + bw - rr, by + rr, rr, -Math.PI / 2, Math.PI / 2); ctx.lineTo(bx + rr, by + bh); ctx.arc(bx + rr, by + rr, rr, Math.PI / 2, Math.PI * 1.5); ctx.closePath();
            ctx.fillStyle = css(C.gel, 0.92); ctx.fill();
            ctx.beginPath(); ctx.moveTo(bx + rr, by + bh * 0.3); ctx.lineTo(bx + bw - rr, by + bh * 0.3); ctx.strokeStyle = css(C['gel-hi'], 0.7); ctx.lineWidth = 1; ctx.stroke();
          }
          /* the contoured foam under them */
          ctx.beginPath();
          for (x = x0; x <= x1; x += 3) { var yy = o.y0 + o.t * 0.74 + Math.sin((x - x0) / (G.S * 0.9)) * o.t * 0.07; if (x === x0) ctx.moveTo(x, yy); else ctx.lineTo(x, yy); }
          ctx.strokeStyle = css(C.cell, 0.6); ctx.lineWidth = 1; ctx.stroke();
        }
        if (k.top === 'wave') {
          /* three zones: the contour is cut closer together in the middle zone */
          ctx.strokeStyle = css(C['cool-line'], 0.55); ctx.lineWidth = 1;
          [1 / 3, 2 / 3].forEach(function (f) { var zx = mix(x0, x1, f); ctx.beginPath(); ctx.setLineDash([2, 3]); ctx.moveTo(zx, o.y0 + 5); ctx.lineTo(zx, o.y1 - 2); ctx.stroke(); ctx.setLineDash([]); });
        }
      }
      ctx.restore();
      /* a hairline along the top of each layer */
      ctx.beginPath();
      for (x = x0; x <= x1; x += 3) { if (x === x0) ctx.moveTo(x, topEdge(o, x)); else ctx.lineTo(x, topEdge(o, x)); }
      ctx.lineTo(x1, topEdge(o, x1));
      ctx.strokeStyle = css(o.kind === 'cover' ? C.ink2 : C.cell, o.kind === 'cover' ? 0.55 : 0.75); ctx.lineWidth = 1; ctx.stroke();
    }
    function paintBed(ctx, sc, alpha) {
      var rand = rng(7 + sc.m.layers.length * 13 + Math.round(sc.m.h)), i, o;
      ctx.save(); ctx.globalAlpha = alpha;
      /* contact shadow and floor */
      var g = ctx.createRadialGradient((G.L + G.R) / 2, G.floor + 3, 4, (G.L + G.R) / 2, G.floor + 3, (G.R - G.L) * 0.56);
      g.addColorStop(0, css(C.shadow, C.dark ? 0.5 : 0.16)); g.addColorStop(1, css(C.shadow, 0));
      ctx.save(); ctx.translate(0, G.floor + 3); ctx.scale(1, 0.05); ctx.translate(0, -(G.floor + 3)); ctx.fillStyle = g; ctx.fillRect(0, G.floor - 200, W, 400); ctx.restore();
      /* top layer first: each layer covers the skirt of the one above it, so a contoured top shows
         and no air layer ever lies under a solid layer's paint */
      for (i = 0; i < sc.layers.length; i++) drawLayer(ctx, sc.layers[i], rand, i === sc.layers.length - 1);
      /* the two cut faces, and the cover lifted a little at the right end to show it is a cover */
      ctx.strokeStyle = css(C.ink2, 0.5); ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(G.L + 0.5, sc.top); ctx.lineTo(G.L + 0.5, G.floor); ctx.moveTo(G.R - 0.5, sc.top); ctx.lineTo(G.R - 0.5, G.floor); ctx.stroke();
      o = sc.layers[0];
      if (o && o.kind === 'cover') {
        ctx.beginPath(); ctx.moveTo(G.R - 26, o.y0); ctx.quadraticCurveTo(G.R - 6, o.y0 - 2, G.R + 9, o.y0 - 9);
        ctx.strokeStyle = css(C.knit, 1); ctx.lineWidth = Math.max(2, o.t * 0.8); ctx.lineCap = 'round'; ctx.stroke(); ctx.lineCap = 'butt';
      }
      ctx.beginPath(); ctx.moveTo(G.L - G.mx * 0.7, G.floor + 0.5); ctx.lineTo(G.R + G.mx * 0.7, G.floor + 0.5);
      ctx.strokeStyle = css(C.floor, 0.85); ctx.lineWidth = 1; ctx.stroke();
      ctx.restore();
    }
    function drawBed() {
      if (!G || !scene) return;
      bed.setTransform(dpr, 0, 0, dpr, 0, 0);
      bed.clearRect(0, 0, W, H);
      if (morph < 1 && oldBed) {
        var t = ease(morph);
        bed.globalAlpha = 1 - t; bed.drawImage(oldBed, 0, 0, W, H); bed.globalAlpha = 1;
        /* the next bed rises (or settles) from the last one's height on the same floor line */
        var k = mix(from.h / cur.h, 1, t);
        if (!newBed) { newBed = document.createElement('canvas'); newBed.width = bedC.width; newBed.height = bedC.height; var nx = newBed.getContext('2d'); nx.setTransform(dpr, 0, 0, dpr, 0, 0); paintBed(nx, scene, 1); }
        bed.save(); bed.translate(0, G.floor); bed.scale(1, k); bed.translate(0, -G.floor); bed.globalAlpha = t; bed.drawImage(newBed, 0, 0, W, H); bed.restore(); bed.globalAlpha = 1;
      } else paintBed(bed, scene, 1);
    }

    /* ---------- the air ---------- */
    var N = 0, P = null, tail = null, head = 0, sub = 0, shift = false, rand = rng(20261006);
    var body = { x: 0.5, to: 0.5, w: 0, wTo: 0 }, flow = 0, flowTo = 0, clock = 0;
    var U = 5.2, Q = 6.4;                         /* idle drift and body draw, inches per second */
    /* per particle: x, y, layer (-1 exhaust), T, age, life, vx, vy */
    var F = 8;
    function count() {
      if (!scene || !scene.hasAir) return 0;
      var a = 0; scene.airLayers.forEach(function (o) { a += o.t * (G.R - G.L); });
      return Math.round(clamp(a / 26, 700, W < 500 ? 1500 : 4200) * budget);
    }
    var budget = 1;
    function pickLayer() { var r = rand(), ls = scene.layers; for (var i = 0; i < ls.length; i++) if (ls[i].air > 0 && r <= ls[i].cum) return ls[i]; return scene.airLayers[scene.airLayers.length - 1]; }
    function spawn(i, anywhere) {
      var o = pickLayer(), b = i * F, x, v;
      if (!anywhere && body.w > 0.2 && rand() < 0.42) {
        /* cool air comes in low, from the room at either side */
        x = rand() < 0.5 ? G.L - rand() * G.mx * 0.75 : G.R + rand() * G.mx * 0.75; v = 0.56 + rand() * 0.36;
      } else { x = mix(G.L, G.R, rand()); v = 0.07 + rand() * 0.86; }
      P[b] = x; P[b + 1] = o.y0 + v * o.t; P[b + 2] = o.i; P[b + 3] = 0; P[b + 4] = anywhere ? rand() * 2 : 0; P[b + 5] = 2.4 + rand() * 3.4; P[b + 6] = 0; P[b + 7] = 0;
      for (var k = 0; k < TAIL; k++) { tail[(i * TAIL + k) * 2] = x; tail[(i * TAIL + k) * 2 + 1] = P[b + 1]; }
    }
    function seed() {
      rand = rng(20261006);
      N = count();
      P = new Float32Array(Math.max(1, N) * F); tail = new Float32Array(Math.max(1, N) * TAIL * 2); head = 0;
      for (var i = 0; i < N; i++) spawn(i, true);
    }
    function step(dt) {
      if (!N) return;
      var ls = scene.layers, bx = mix(G.L, G.R, body.x), bw = G.S * 7.5, B = body.w, S = G.S, top = scene.top, R2 = Math.pow(S * 6.5, 2) * 2, i, b, o, x, y, v, th, se, sv, u, vy, d2, T, wob;
      clock += dt;
      if (++sub >= 3) { sub = 0; head = (head + 1) % TAIL; shift = true; } else shift = false;
      for (i = 0; i < N; i++) {
        b = i * F; x = P[b]; y = P[b + 1]; T = P[b + 3];
        P[b + 4] += dt;
        if (P[b + 2] < 0) {
          /* exhaust: out in the room, slowing, rising if warm, thinning */
          P[b + 6] *= 1 - 1.1 * dt; P[b + 7] -= (10 + 85 * T) * dt * S / 14;
          x += P[b + 6] * dt; y += P[b + 7] * dt;
          if (P[b + 4] > P[b + 5] || x < -4 || x > W + 4 || y < 2) { spawn(i); continue; }
        } else {
          o = ls[P[b + 2]];
          v = clamp((y - o.y0) / o.t, 0.02, 0.98);
          th = Math.tanh((x - bx) / bw); se = 1 - th * th;
          sv = Math.sin(TAU * v);
          u = o.air * S * (U * flow * (1 - Math.cos(TAU * v)) * 0.6 + B * Q * Math.PI * sv * th);
          if (o.k.top && v < 0.3) u *= 1 + 0.9 * (1 - v / 0.3);              /* quicker along a contour or a channel */
          vy = -B * Q * S * o.air * o.t * Math.pow(Math.sin(Math.PI * v), 2) * se / bw;
          /* a meander the size of the cells, kept off the walls */
          wob = Math.sin(Math.PI * v);
          u += o.air * S * 1.1 * flow * Math.sin(y * 0.21 + x * 0.013 + clock * 0.7 + o.i);
          vy += wob * o.air * S * 0.9 * (flow + B) * 0.5 * Math.sin(x * 0.045 + clock * 0.9 + o.i * 2.1 + y * 0.05);
          x += u * dt; y += vy * dt;
          y = clamp(y, o.y0 + o.t * 0.03, o.y1 - o.t * 0.03);
          /* warmed near the body, then it gives the heat back over a few seconds */
          d2 = (x - bx) * (x - bx) + (y - top) * (y - top) * 1.6;
          T += (o.i <= scene.warmTo ? B * Math.exp(-d2 / R2) * dt * 1.9 : 0) - T * dt / 2.1;
          T = T > 1 ? 1 : T < 0 ? 0 : T;
          if ((x > G.R && u > 0) || (x < G.L && u < 0)) {
            P[b + 2] = -1; P[b + 6] = u * 0.9 + (u > 0 ? 14 : -14); P[b + 7] = 0; P[b + 4] = 0; P[b + 5] = 0.7 + rand() * 1.1;
          } else if (P[b + 4] > P[b + 5]) { spawn(i); continue; }
        }
        P[b] = x; P[b + 1] = y; P[b + 3] = T;
        tail[(i * TAIL + head) * 2] = x; tail[(i * TAIL + head) * 2 + 1] = y;
      }
    }
    var BUCKETS = 5;
    function airColor(k) { var t = k / (BUCKETS - 1); return t < 0.6 ? blend(C.cool, C.warm, t / 0.6) : blend(C.warm, C.hot, (t - 0.6) / 0.4); }
    function drawBody(ctx) {
      if (body.w < 0.02 || !scene) return;
      var bx = mix(G.L, G.R, body.x), y = scene.top, r = G.S * 5.2, g = ctx.createRadialGradient(bx, y - r * 0.2, 2, bx, y - r * 0.2, r);
      g.addColorStop(0, css(C.body, 0.5 * body.w)); g.addColorStop(0.55, css(C.warm, 0.16 * body.w)); g.addColorStop(1, css(C.warm, 0));
      ctx.save(); ctx.beginPath(); ctx.rect(0, 0, W, y + 1); ctx.clip();
      ctx.translate(bx, y); ctx.scale(1.5, 0.5); ctx.translate(-bx, -y); ctx.fillStyle = g; ctx.fillRect(bx - r, y - r * 1.4, r * 2, r * 1.5); ctx.restore();
      /* where it rests on the cover */
      ctx.beginPath(); ctx.moveTo(bx - G.S * 4.6, y - 1); ctx.quadraticCurveTo(bx, y + 3.5 * body.w, bx + G.S * 4.6, y - 1);
      ctx.strokeStyle = css(C.hot, 0.85 * body.w); ctx.lineWidth = 2.4; ctx.lineCap = 'round'; ctx.stroke(); ctx.lineCap = 'butt';
    }
    /* comets: one path per temperature and tail position, so a frame is a few dozen strokes */
    function drawComets(ctx, gain) {
      var k, s, i, b, a, c, lo, hi, x0, y0, x1, y1, T, exhaust, life;
      for (k = 0; k < BUCKETS; k++) {
        c = airColor(k); lo = k / BUCKETS; hi = (k + 1) / BUCKETS;
        for (s = 0; s < TAIL - 1; s++) {
          ctx.beginPath();
          for (i = 0; i < N; i++) {
            b = i * F; T = P[b + 3];
            if (T < lo || (T >= hi && k < BUCKETS - 1)) continue;
            a = P[b + 4];
            if (a < 0.03 * (s + 1)) continue;                                   /* the tail grows out after a spawn */
            x0 = tail[(i * TAIL + (head - s + TAIL) % TAIL) * 2]; y0 = tail[(i * TAIL + (head - s + TAIL) % TAIL) * 2 + 1];
            x1 = tail[(i * TAIL + (head - s - 1 + TAIL * 2) % TAIL) * 2]; y1 = tail[(i * TAIL + (head - s - 1 + TAIL * 2) % TAIL) * 2 + 1];
            if (Math.abs(x0 - x1) > 40) continue;
            ctx.moveTo(x0, y0); ctx.lineTo(x1, y1);
          }
          ctx.strokeStyle = css(c, (0.52 + 0.3 * lo) * TAIL_A[s] * gain);
          ctx.lineWidth = (1 + 0.75 * lo) * (1 - s * 0.13);
          ctx.stroke();
        }
      }
    }
    function drawAir() {
      air.setTransform(dpr, 0, 0, dpr, 0, 0);
      air.clearRect(0, 0, W, H);
      if (!scene || !scene.hasAir) return;
      air.lineCap = 'round';
      drawComets(air, morph < 1 ? 0.35 + 0.65 * morph : 1);
      drawBody(air);
    }
    /* the still: the same air, with its trails left to build up into flow lines */
    function drawStill(at) {
      layout(); if (!G) return;
      scene = build(cur); morph = 1; drawBed();
      air.setTransform(dpr, 0, 0, dpr, 0, 0); air.clearRect(0, 0, W, H);
      if (!scene.hasAir) return;
      seed();
      body.x = body.to = at == null ? 0.5 : at; body.w = body.wTo = 0.8; flow = 1; clock = 0;
      air.lineCap = 'round';
      var n, i, b, k, c, T, x0, y0, x1, y1, lo, hi, prev;
      for (n = 0; n < 150; n++) {
        prev = head; sub = 2; step(1 / 50);                                   /* a tail position every step here */
        if (n < 36) continue;                                                    /* let the body's warmth spread first */
        for (k = 0; k < BUCKETS; k++) {
          c = airColor(k); lo = k / BUCKETS; hi = (k + 1) / BUCKETS;
          air.beginPath();
          for (i = 0; i < N; i += 2) {
            b = i * F; T = P[b + 3];
            if (T < lo || (T >= hi && k < BUCKETS - 1)) continue;
            x0 = tail[(i * TAIL + prev) * 2]; y0 = tail[(i * TAIL + prev) * 2 + 1]; x1 = tail[(i * TAIL + head) * 2]; y1 = tail[(i * TAIL + head) * 2 + 1];
            if (Math.abs(x0 - x1) > 30 || P[b + 4] < 0.04) continue;
            air.moveTo(x0, y0); air.lineTo(x1, y1);
          }
          air.strokeStyle = css(c, 0.085 + 0.03 * lo); air.lineWidth = 1 + 0.35 * lo; air.stroke();     /* warm lines stay as fine as cool ones */
        }
      }
      drawComets(air, 0.7);
      drawBody(air);
    }

    /* ---------- running ---------- */
    var raf = 0, last = 0, onScreen = false, idle = 0, introAt = 0, introDone = false, live = false, ms = 0, frames = 0, slow = 0, pointerIn = false;
    function goLive() { if (!live) { live = true; stage.classList.add('is-live'); } }
    function frame(now) {
      var real = Math.min(0.25, (now - last) / 1000 || 0.016), dt = Math.min(1 / 30, real), t0 = performance.now();
      last = now;
      if (!G || !scene) { raf = 0; return; }
      if (introAt) {
        /* one breath of warm air through the middle of the bed */
        var q = (now - introAt) / 3400;
        if (q >= 1) { introAt = 0; body.wTo = pointerIn ? 1 : 0; flowTo = 0.6; }
        else { body.to = 0.5; body.wTo = Math.sin(Math.PI * clamp(q * 1.15, 0, 1)); flowTo = 0.25 + 0.75 * Math.sin(Math.PI * q); }
      }
      body.x += (body.to - body.x) * (1 - Math.exp(-dt / 0.09));
      body.w += (body.wTo - body.w) * (1 - Math.exp(-dt / 0.38));
      flow += (flowTo - flow) * (1 - Math.exp(-dt / 0.7));
      if (morph < 1) { morph = Math.min(1, morph + dt / 0.6); drawBed(); if (morph >= 1) { oldBed = null; newBed = null; } }
      step(dt);
      try { drawAir(); } catch (e) { raf = 0; return; }
      goLive();
      /* budget: if frames run long, carry fewer particles */
      if (morph >= 1) ms += (performance.now() - t0 - ms) * 0.08;
      frames++;
      if (ms > 9 && frames > 40 && morph >= 1) { if (++slow > 30 && budget > 0.45) { budget *= 0.8; slow = 0; seed(); } } else slow = 0;
      /* nobody near: go calm, then slow to a stop and sleep. The wait runs on the clock, not on
         frames, so a slow device sleeps as soon as a fast one. */
      idle = (pointerIn || introAt || morph < 1 || body.wTo > 0) ? 0 : idle + real;
      if (idle > 7) flowTo = 0;
      if ((idle > 7 && flow < 0.015 && body.w < 0.02) || idle > 10) { flow = 0; raf = 0; return; }
      raf = onScreen && !document.hidden ? requestAnimationFrame(frame) : 0;
    }
    function wake() {
      if (lite || raf || !onScreen || document.hidden || !G || !scene || !scene.hasAir) return;
      idle = 0; if (!introAt && flowTo < 0.6) flowTo = 0.6;
      last = performance.now(); raf = requestAnimationFrame(frame);
    }
    function sleep() { if (raf) cancelAnimationFrame(raf); raf = 0; }

    /* ---------- the stepper, the photo, the details and the prices ---------- */
    function sizeNow() { var b = root.querySelector('[data-sizes] button[aria-pressed="true"]'); return (b && b.getAttribute('data-size')) || root.getAttribute('data-default-size') || 'Queen'; }
    var sizeCache = {};
    function sizesOf(rowId) {
      if (sizeCache[rowId]) return sizeCache[rowId];
      var row = document.getElementById(rowId), out = [];
      if (row) Array.prototype.forEach.call(row.querySelectorAll('[data-sizes-json]'), function (s) { try { out.push(JSON.parse(s.textContent)); } catch (e) { /* skip */ } });
      return (sizeCache[rowId] = out);
    }
    function prices() {
      var size = sizeNow();
      steps.forEach(function (st) {
        var low = 0, id = st.getAttribute('data-af-step');
        sizesOf(st.getAttribute('data-af-row')).forEach(function (s) { var e = s[size]; if (e && (!low || e.price < low)) low = e.price; });
        var text = low ? money(low) : 'Not made in ' + size;
        setText(st.querySelector('[data-af-price]'), text);
        details.forEach(function (d) {
          if (d.getAttribute('data-af-detail') !== id) return;
          setText(d.querySelector('[data-af-price]'), text); setText(d.querySelector('[data-af-size]'), low ? size : '');
        });
      });
    }
    function show(m, quiet) {
      steps.forEach(function (st) { var on = String(st.getAttribute('data-af-step') === m.id); if (st.getAttribute('aria-pressed') !== on) st.setAttribute('aria-pressed', on); });
      details.forEach(function (d) { setHidden(d, d.getAttribute('data-af-detail') !== m.id); });
      photos.forEach(function (p) { setHidden(p, p.getAttribute('data-af-photo') !== m.id || p.__bad === true); });
      if (stage.getAttribute('data-model') !== m.id) stage.setAttribute('data-model', m.id);
      stage.classList.toggle('is-noair', !m.hasAir);
      if (!quiet) setText(statusEl, m.name || '');
    }
    function setModel(id, now) {
      var m = modelById(id);
      if (!m || !G) return;
      if (m !== cur) {
        from = cur; cur = m;
        if (!now && !lite && scene && m.hasAir && onScreen && !document.hidden) {
          oldBed = document.createElement('canvas'); oldBed.width = bedC.width; oldBed.height = bedC.height;
          oldBed.getContext('2d').drawImage(bedC, 0, 0);
          morph = 0; newBed = null;
        } else { morph = 1; oldBed = null; newBed = null; }
      }
      show(cur);
      if (lite) { drawStill(); goLive(); return; }
      scene = build(cur); seed(); drawBed(); drawAir();
      if (!scene.hasAir) goLive();
      if (now) return;
      wake();
    }
    stage.addEventListener('click', function (e) {
      /* the link to a row: if a filter is hiding that row, clear the filters first, so the jump has
         somewhere to land */
      var go = e.target.closest && e.target.closest('[data-af-go]');
      if (go && stage.contains(go)) {
        var row = document.getElementById((go.getAttribute('href') || '').replace('#', ''));
        if (row && row.hidden) {
          var all = root.querySelector('[data-feels] [data-feel="all"]'), floor = root.querySelector('[data-floor-only][aria-pressed="true"]');
          if (all && all.getAttribute('aria-pressed') !== 'true') all.click();
          if (floor && row.hidden) floor.click();
        }
        return;
      }
      var st = e.target.closest && e.target.closest('[data-af-step]');
      if (!st || !stage.contains(st)) return;
      if (introAt) { introAt = 0; body.wTo = pointerIn ? 1 : 0; flowTo = 0.6; }       /* a step pressed mid-breath ends the breath */
      setModel(st.getAttribute('data-af-step'));
      var bar = st.parentNode;
      if (bar && bar.scrollWidth > bar.clientWidth + 2) bar.scrollTo({ left: st.offsetLeft - (bar.clientWidth - st.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    });
    stage.addEventListener('keydown', function (e) {
      var st = e.target.closest && e.target.closest('[data-af-step]'), d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!st || !d) return;
      var next = steps[steps.indexOf(st) + d];
      if (!next) return;
      e.preventDefault(); next.focus(); next.click();
    });
    photos.forEach(function (p) {
      function bad() { p.__bad = true; setHidden(p, true); }
      p.addEventListener('error', bad);
      if (p.complete && !p.naturalWidth && !p.hidden) bad();
    });
    var sizeGroup = root.querySelector('[data-sizes]');
    if (sizeGroup && 'MutationObserver' in window) new MutationObserver(prices).observe(sizeGroup, { attributes: true, subtree: true, attributeFilter: ['aria-pressed'] });

    /* ---------- the warm body follows the pointer ---------- */
    function aim(e) {
      if (!G) return;
      if (!rect) rect = box.getBoundingClientRect();       /* cleared by a scroll; read here, never in the frame loop */
      body.to = clamp((e.clientX - rect.left - G.L) / (G.R - G.L), 0.04, 0.96);
      body.wTo = 1; pointerIn = true; introAt = 0; if (flowTo < 1) flowTo = 1;
      wake();
    }
    var release = 0;
    function letGo() { pointerIn = false; body.wTo = 0; if (flowTo > 0.6) flowTo = 0.6; wake(); }
    if (!lite) {
      box.addEventListener('pointerenter', function (e) { rect = box.getBoundingClientRect(); if (e.pointerType === 'mouse') aim(e); });
      box.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' || pointerIn) aim(e); });
      box.addEventListener('pointerdown', function (e) { clearTimeout(release); rect = box.getBoundingClientRect(); aim(e); });
      box.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') letGo(); });   /* a touch ends on pointerup, below */
      box.addEventListener('pointercancel', letGo);
      /* a finger lifted: the body stays a moment, then fades; the next touch cancels the wait */
      box.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') { clearTimeout(release); release = setTimeout(letGo, 1400); } });
      /* both remove themselves once this stage has left the page (the theme editor re-renders a section) */
      var gone = function () { if (document.documentElement.contains(box)) return false; document.removeEventListener('visibilitychange', onVis); window.removeEventListener('scroll', onScroll); sleep(); return true; };
      var onVis = function () { if (gone()) return; if (document.hidden) sleep(); else wake(); };
      var onScroll = function () { if (gone()) return; rect = null; };
      document.addEventListener('visibilitychange', onVis);
      window.addEventListener('scroll', onScroll, { passive: true });
      box.addEventListener('pointerover', function () { if (!rect) rect = box.getBoundingClientRect(); });
    }

    /* ---------- start ---------- */
    var drawnFor = '';
    function repaint() {
      var r0 = box.getBoundingClientRect(), paper0 = C.paper ? C.paper.join() : '';
      readColors();
      /* the shared script calls this on every window resize, and a phone resizes the window each
         time its address bar slides away. Same box, same colors: nothing to redo. */
      var sig = Math.round(r0.width) + 'x' + Math.round(r0.height) + '|' + C.paper.join() + '|' + C.cool.join();
      if (sig === drawnFor && G && scene) { rect = r0; return; }
      drawnFor = sig;
      layout();
      if (!G) return;
      if (lite) { stage.classList.add('is-still'); try { drawStill(); goLive(); } catch (e) { /* the poster stays */ } return; }
      scene = build(cur); morph = 1; oldBed = null; newBed = null;
      seed(); drawBed(); drawAir();
      if (!scene.hasAir) goLive();
      wake();
    }
    function begin(visible) {
      onScreen = visible;
      if (!visible) { sleep(); return; }
      if (!introDone && !lite && scene && scene.hasAir) {
        introDone = true;
        if (!window.__moAfNoIntro) { introAt = performance.now() + 500; flow = 0; flowTo = 0.25; body.w = 0; }
        else flowTo = 0.6;
      }
      wake();
    }
    show(cur, true);
    prices();
    if (!saver) {
      var base = (window.__moAfAssets || {}), src = (document.currentScript && document.currentScript.src) || '';
      tile('open', base.open || stage.getAttribute('data-af-foam-open') || 'assets/foam-open.webp');
      tile('dense', base.dense || stage.getAttribute('data-af-foam-dense') || 'assets/foam-dense.webp');
    }
    try { repaint(); } catch (e) { return function () {}; }
    if (!lite) {
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { begin(es[0].isIntersecting); }, { threshold: 0.25 }).observe(box);
      else begin(true);
    }

    /* hooks for QA and for rendering the poster; harmless in production */
    stage.__airflow = {
      model: function (id) { setModel(id, true); },
      body: function (x, w) { if (x == null) { letGo(); return; } body.to = clamp(x, 0.04, 0.96); body.wTo = w == null ? 1 : w; pointerIn = body.wTo > 0; introAt = 0; flowTo = 1; wake(); },
      breath: function () { introAt = performance.now(); wake(); },
      still: function (opts) { sleep(); drawStill(opts && opts.body); goLive(); },
      png: function () { var c = document.createElement('canvas'); c.width = bedC.width; c.height = bedC.height; var x = c.getContext('2d'); x.drawImage(bedC, 0, 0); x.drawImage(airC, 0, 0); return c.toDataURL('image/png'); },
      stats: function () {
        var warm = 0, inside = 0, i, b, o;
        for (i = 0; i < N; i++) { b = i * F; if (P[b + 3] > 0.25) warm++; if (P[b + 2] >= 0) { o = scene.layers[P[b + 2]]; if (o.air <= 0 || P[b + 1] < o.y0 - 0.5 || P[b + 1] > o.y1 + 0.5) inside++; } }
        return { particles: N, warm: warm, inSolid: inside, awake: !!raf, model: cur.id, ms: Math.round(ms * 100) / 100, frames: frames, noair: !scene || !scene.hasAir, still: lite };
      },
      wake: wake, sleep: sleep
    };
    return repaint;
  };
})();

/* ==================================================================================
 * Row drawing: a Molecule side view with the cover cut back (2026-10-06)
 * Part of mo-lineup-molecule.js. Registers window.MOLineupDraw.molecule, which the shared script
 * (assets/mo-brand-lineup.js) calls once per version of each row and writes into the row's
 * [data-xsec] slot. Returns one <svg> string. No DOM writes, no libraries.
 *
 * Same frame as the shared cutaway(), so rows compare with other pages: viewBox 204 x 112, floor
 * at 103, 5 units per inch. Total height is true. Molecule publishes the order of the layers and
 * no depths, so the split between layers is illustrative (the weights below); a label that
 * carries a depth ("CoolVENT open-cell foam, 2 in.") wins for its layer.
 *
 * The finished cover is on the left third. Right of the cut, the layers, each drawn its own way:
 *   cover           a thin knit lid over the cut
 *   open            open-cell foam, medium cells                        air
 *   zoned           a contoured top in three zones, small pores         air
 *   base-air        dense base foam, fine cells                         air (it creeps)
 *   vent            open-cell foam, large open cells                    air
 *   airtec          springy foam, large round cells                     air
 *   airtec-channel  the same, an egg-crate top with channels cut in     air
 *   lift            contoured foam, gel bands across the middle third   solid
 *   base            dense base foam, fine tight cells                   solid
 *   anything else   plain foam                                          solid
 * A layer that passes air carries two or three cool-blue hairlines that taper at both ends: the
 * row's airflow mark. They are static. Cover, lift and base never get one.
 * The length of the exposed side stands for the length of the bed: the three zones and the middle
 * third are laid out on it.
 *
 * Lift: every layer group but the base is <g class="c-lift" style="--lift:N">. The shared CSS
 * moves those apart when "See the layers" is pressed.
 * Colors: classes only (m-*), styled in mo-lineup-molecule.css from the --af-* tokens.
 * ================================================================================== */
(function () {
  'use strict';
  if (window.MOLineupMoleculeDraw) return;
  window.MOLineupMoleculeDraw = true;

  var draws = window.MOLineupDraw = window.MOLineupDraw || {};

  var VW = 204, VH = 112, X0 = 14, X1 = 198, U = 5, FLOOR = 103;
  var COV = 0.4 * U, SLOPE = 0.2, STEP = 4.5, OUT = 3.4;
  /* illustrative depths in inches; base and base-air take what is left */
  var WEIGHT = { open: 2.5, zoned: 3, vent: 2, airtec: 2.5, 'airtec-channel': 2.5, lift: 3 };
  /* how freely air moves, from Molecule's own claims. It sets the length and weight of the
     hairlines and is never printed. A kind that is not listed here is solid. */
  var EASE = { open: 0.6, zoned: 0.5, 'base-air': 0.2, vent: 0.85, airtec: 1, 'airtec-channel': 1 };
  var cutN = 0;

  function n1(v) { return Math.round(v * 10) / 10; }
  function n2(v) { return Math.round(v * 100) / 100; }
  function isBase(k) { return k === 'base' || k === 'base-air'; }

  /* a small seeded generator, so a drawing is the same on every load */
  function lcg(text) {
    var s = 7, i;
    for (i = 0; i < text.length; i++) s = (s * 31 + text.charCodeAt(i)) % 4294967296;
    return function () { s = (s * 1664525 + 1013904223) % 4294967296; return s / 4294967296; };
  }

  /* rounded bumps from xa to xb, valleys on the line yv, crests a above it */
  function bumps(xa, xb, yv, a, pitch) {
    var count = Math.max(1, Math.round((xb - xa) / pitch)), p = (xb - xa) / count, d = '', valleys = [], j;
    for (j = 0; j < count; j++) {
      d += 'Q' + n1(xa + p * (j + 0.5)) + ',' + n1(yv - a * 2) + ' ' + n1(xa + p * (j + 1)) + ',' + n1(yv);
      if (j < count - 1) valleys.push(xa + p * (j + 1));
    }
    return { d: d, valleys: valleys };
  }

  /* a lazy wave about the line ym, from node j0 to node j1 (nodes are half a pitch apart) */
  function swell(xs, ym, a, half, j0, j1) {
    var d = 'M' + n1(xs + half * j0) + ',' + n1(ym) + 'Q' + n1(xs + half * (j0 + 0.5)) + ',' + n1(ym + (j0 % 2 ? a : -a)) + ' ' + n1(xs + half * (j0 + 1)) + ',' + n1(ym), j;
    for (j = j0 + 2; j <= j1; j++) d += 'T' + n1(xs + half * j) + ',' + n1(ym);
    return d;
  }

  /* one airflow hairline: a thin filled shape along a slow wave, a long fine tail on the left
     and a short taper on the right. No arrowhead. */
  function streak(xa, xb, yc, sway, phase, w) {
    var N = 12, up = [], dn = [], i, t, x, y, hw;
    for (i = 0; i <= N; i++) {
      t = i / N; x = xa + (xb - xa) * t;
      y = yc + sway * Math.sin(x / 7.2 + phase);
      hw = w * Math.pow(Math.min(1, t / 0.62), 0.8) * Math.min(1, (1 - t) / 0.14);
      up.push(n2(x) + ',' + n2(y - hw)); dn.unshift(n2(x) + ',' + n2(y + hw));
    }
    return 'M' + up.join('L') + 'L' + dn.join('L') + 'Z';
  }

  function draw(version, inches, kinds) {
    var lis = version && version.querySelectorAll ? Array.prototype.slice.call(version.querySelectorAll('.mo-lineup__layers li')) : [];
    var src = lis.length ? lis.map(function (li) { return { k: li.getAttribute('data-kind') || '', t: li.textContent || '' }; })
      : (kinds || []).map(function (k) { return { k: k, t: '' }; });
    /* a kind becomes a class name, so keep only what a class name may hold */
    var layers = src.map(function (x) { return { k: String(x.k).trim().toLowerCase().replace(/[^a-z0-9-]/g, ''), t: String(x.t) }; })
      .filter(function (l) { return l.k; });
    var cover = layers.filter(function (l) { return l.k === 'cover'; })[0] || { k: 'cover', t: '' };
    var body = layers.filter(function (l) { return l.k !== 'cover'; });
    if (!body.length) body = [{ k: 'foam', t: '' }];
    var rnd = lcg(kinds && kinds.length ? kinds.join(',') : layers.map(function (l) { return l.k; }).join(','));
    /* the Reflex cover is grey with a navy panel; the Core cover is white with a hex quilt */
    var reflex = !/shield/i.test(cover.t) && (/instant/i.test(cover.t) || body.some(function (l) { return /^(vent|airtec|airtec-channel|lift)$/.test(l.k); }));

    var id = 'mo-mcut-' + (++cutN);
    var h = Math.max(40, Math.min((parseFloat(inches) || 10) * U, 90)), top = FLOOR - h;
    var CUT = X0 + (X1 - X0) * 0.33;
    function cx(y) { return CUT + (y - top) * SLOPE; }

    /* depths: a depth in the label, else the weight; the base takes the rest, at least 30% */
    var room = h - COV, sum = 0, rest = [], share, scale;
    body.forEach(function (l) {
      var m = /(\d+(?:\.\d+)?)\s*in\./i.exec(l.t), inch = m ? parseFloat(m[1]) : 0;
      if (!(inch > 0) && isBase(l.k)) { rest.push(l); return; }
      l.hh = (inch > 0 ? inch : WEIGHT[l.k] || 2) * U;
      sum += l.hh;
    });
    if (rest.length) {
      share = Math.max(room - sum, h * 0.3);
      scale = sum > room - share ? (room - share) / sum : 1;
      rest.forEach(function (l) { l.hh = share / rest.length; });
    } else scale = room / sum;
    body.forEach(function (l) { if (rest.indexOf(l) < 0) l.hh *= scale; });
    /* lifts, counted from the bottom: a base at the bottom stays on the floor */
    var level = 0, i;
    for (i = body.length - 1; i >= 0; i--) {
      if (isBase(body[i].k) && !level) body[i].lift = 0;
      else { level++; body[i].lift = level * STEP; }
    }

    var side = 'M' + (X0 + 3.5) + ',' + n1(top) + 'H' + n1(cx(top)) + 'L' + n1(cx(FLOOR)) + ',' + FLOOR + 'H' + (X0 + 3.5) +
      'Q' + X0 + ',' + FLOOR + ' ' + X0 + ',' + (FLOOR - 3.5) + 'V' + n1(top + 3.5) + 'Q' + X0 + ',' + n1(top) + ' ' + (X0 + 3.5) + ',' + n1(top) + 'Z';
    var o = '<defs><linearGradient id="' + id + 'g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".26"/><stop offset=".5" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".07"/></linearGradient>' +
      '<clipPath id="' + id + 'f"><path d="' + side + '"/></clipPath></defs>';
    o += '<ellipse class="c-shadow" cx="' + ((X0 + X1) / 2) + '" cy="' + (FLOOR + 2.6) + '" rx="' + ((X1 - X0) / 2 + 5) + '" ry="2.4"/>';
    o += '<path class="c-dim" d="M6,' + n1(top) + 'V' + FLOOR + 'M3.2,' + n1(top) + 'h5.6M3.2,' + FLOOR + 'h5.6"/>';

    /* ---------- the finished side, left of the cut ---------- */
    var x, y, r, d;
    o += '<path class="m-side" d="' + side + '"/><g clip-path="url(#' + id + 'f)">';
    if (reflex) {
      /* grey knit top edge, a charcoal band of diamonds, heather sides, the navy panel at the foot */
      var bandT = top + 1.4, bandB = top + 7.2, cutB = cx(FLOOR);
      o += '<path class="m-wedge" d="M' + X0 + ',' + n1(top + h * 0.5) + 'L' + n1(cutB + 12) + ',' + n1(FLOOR - h * 0.04) + 'V' + FLOOR + 'H' + X0 + 'Z"/>';
      o += '<rect class="m-band" x="' + X0 + '" y="' + n1(bandT) + '" width="' + n1(cutB - X0) + '" height="' + n1(bandB - bandT) + '"/>';
      d = '';
      for (x = X0 - 6; x < cutB; x += 2.4) d += 'M' + n1(x) + ',' + n1(bandB) + 'l5.8,-5.8M' + n1(x) + ',' + n1(bandT) + 'l5.8,5.8';
      o += '<path class="m-diamond" d="' + d + '"/>';
      o += '<rect class="m-top" x="' + X0 + '" y="' + n1(top) + '" width="' + n1(cutB - X0) + '" height="1.4"/>';
      o += '<path class="m-pipe" d="M' + X0 + ',' + n1(bandB) + 'H' + n1(cutB) + '"/>';
    } else {
      /* white knit quilted in hexagons, pale blue stitch, the small navy label */
      var R = 3.5, hw = R * 0.866, row = 0;
      d = '';
      for (y = top - R; y < FLOOR + R; y += R * 1.5, row++)
        for (x = X0 - hw * 2 + (row % 2) * hw; x < cx(y) + hw; x += hw * 2)
          d += 'M' + n1(x - hw) + ',' + n1(y - R / 2) + 'l' + n1(hw) + ',' + n1(-R / 2) + 'l' + n1(hw) + ',' + n1(R / 2) + 'v' + R;
      o += '<path class="m-hex" d="' + d + '"/>';
      o += '<rect class="m-tag" x="' + n1(cx(top + 6) - 19) + '" y="' + n1(top + 5) + '" width="12.5" height="3.6" rx=".5"/>';
      o += '<path class="m-tagline" d="M' + n1(cx(top + 6) - 17) + ',' + n1(top + 6.8) + 'h8.5"/>';
    }
    o += '</g><path class="m-side-line" d="' + side + '"/>';
    /* the cut edge of the cover: a pale lip, so the cover reads as a skin that was cut back */
    o += '<path class="m-lip" d="M' + n1(cx(top) - 1.5) + ',' + n1(top) + 'H' + n1(cx(top)) + 'L' + n1(cx(FLOOR)) + ',' + FLOOR + 'H' + n1(cx(FLOOR) - 1.5) + 'Z"/>';

    /* ---------- the layers, top to bottom ---------- */
    y = top + COV;
    body.forEach(function (l, idx) {
      var k = l.k, y0 = y, y1 = y + l.hh, last = idx === body.length - 1, ease = EASE[k] || 0;
      var end = (last ? 'V' + n1(y1 - 3) + 'Q' + X1 + ',' + n1(y1) + ' ' + (X1 - 3) + ',' + n1(y1) : 'V' + n1(y1)) + 'H' + n1(cx(y1)) + 'Z';
      var shape, a = 0, ya = y0 + 0.9, yb = y1 - 0.9, xs, span, edge = '', extra = '', behind = '', front = '', cells = '', dots = '', rows, yy, xx, w, j, q, t0;
      var thick = l.hh >= 5;

      if (k === 'zoned' && thick) {
        /* three zones along the bed: tall soft bumps, tight firm ones in the middle, medium ones */
        a = Math.min(1.7, l.hh * 0.2); xs = cx(y0 + a); span = X1 - xs;
        var z1 = xs + span / 3, z2 = xs + span * 2 / 3, yv = y0 + a;
        var b1 = bumps(xs, z1, yv, a, 7), b2 = bumps(z1, z2, yv, a * 0.6, 3.7), b3 = bumps(z2, X1, yv, a * 0.85, 5.3);
        edge = 'M' + n1(xs) + ',' + n1(yv) + b1.d + b2.d + b3.d;
        extra = '<path class="m-zone" d="M' + n1(z1) + ',' + n1(yv) + b2.d + 'V' + n1(y1) + 'H' + n1(z1) + 'Z"/>' +
          '<path class="m-zline" d="M' + n1(z1) + ',' + n1(yv) + 'V' + n1(y1 - 1) + 'M' + n1(z2) + ',' + n1(yv) + 'V' + n1(y1 - 1) + '"/>' +
          '<path class="m-echo" d="' + edge + '" transform="translate(0 1.9)"/>';
        ya = yv + 2.8;
      } else if (k === 'airtec-channel' && thick) {
        /* an egg-crate top; the valleys are the air channels, with a slit cut down from each */
        a = Math.min(2.1, l.hh * 0.2); xs = cx(y0 + a); span = X1 - xs;
        var eg = bumps(xs, X1, y0 + a, a, 5.2);
        edge = 'M' + n1(xs) + ',' + n1(y0 + a) + eg.d;
        d = '';
        eg.valleys.forEach(function (vx) { d += 'M' + n1(vx) + ',' + n1(y0 + a - 0.2) + 'v' + n1(Math.min(3, l.hh * 0.24)); });
        extra = '<path class="m-slit" d="' + d + '"/>';
        ya = y0 + a + 3.2;
      } else if (k === 'lift' && thick) {
        /* a contoured top, and gel bands under the middle third */
        a = Math.min(2.6, l.hh * 0.2); xs = cx(y0 + a / 2); span = X1 - xs;
        var ym = y0 + a / 2, halves = Math.max(2, Math.round(span / 9) * 2), half = span / halves;
        var g0 = Math.round(halves / 3), g1 = Math.round(halves * 2 / 3), gx0 = xs + half * g0, gx1 = xs + half * g1;
        edge = swell(xs, ym, a, half, 0, halves);
        d = swell(xs, ym, a, half, g0, g1);
        extra = '<path class="m-echo" d="' + edge + '" transform="translate(0 ' + n1(l.hh * 0.42) + ')"/>' +
          '<path class="m-gel" d="' + d + '" transform="translate(0 1.25)"/><path class="m-gel-hi" d="' + d + '" transform="translate(0 .8)"/>';
        d = '';
        for (yy = ym + a / 2 + 3.4, j = 0; yy < y1 - 1.8; yy += 3.3, j++) d += 'M' + n1(gx0 + (j % 2) * 2) + ',' + n1(yy) + 'H' + n1(gx1);
        if (d) extra += '<path class="m-gel-dash" d="' + d + '"/>';
      }
      shape = (edge || 'M' + n1(cx(y0)) + ',' + n1(y0) + 'H' + X1) + end;

      /* cells: one path per layer */
      function ring(x0, y0c, rx, ry) { return 'M' + n1(x0 - rx) + ',' + n1(y0c) + 'a' + n1(rx) + ',' + n1(ry) + ' 0 1,0 ' + n1(rx * 2) + ',0a' + n1(rx) + ',' + n1(ry) + ' 0 1,0 ' + n1(-rx * 2) + ',0'; }
      function scatter(px, py, pad, fn) {
        if (yb - ya < pad * 2) return;
        rows = Math.max(1, Math.round((yb - ya) / py));
        for (q = 0; q < rows; q++) {
          yy = ya + (q + 0.5) * (yb - ya) / rows;
          for (xx = cx(yy) + pad + 0.8 + (q % 2) * px / 2 + rnd() * px * 0.3; xx < X1 - pad - 0.6; xx += px * (0.86 + 0.28 * rnd())) fn(xx, yy);
        }
      }
      if (k === 'open') scatter(4.7, 3.7, 1.1, function (x0, y0c) { w = 0.6 + rnd() * 0.45; cells += ring(x0, y0c + (rnd() - 0.5) * 0.9, w, w); });
      else if (k === 'vent') scatter(7.4, 4.6, 2.3, function (x0, y0c) { w = 1.6 + rnd() * 0.75; cells += ring(x0, y0c + (rnd() - 0.5) * 1.1, w, w * (0.62 + rnd() * 0.16)); });
      else if (k === 'airtec' || k === 'airtec-channel') scatter(5.6, 4.6, 2, function (x0, y0c) { w = 1.5 + rnd() * 0.45; cells += ring(x0, y0c + (rnd() - 0.5) * 0.7, w, w); });
      else if (k === 'base') scatter(2.3, 2.2, 0.5, function (x0, y0c) { dots += 'M' + n1(x0) + ',' + n1(y0c + (rnd() - 0.5) * 0.5) + 'h.01'; });
      else if (k === 'base-air') scatter(3.1, 2.7, 0.6, function (x0, y0c) { dots += 'M' + n1(x0) + ',' + n1(y0c + (rnd() - 0.5) * 0.7) + 'h.01'; });
      else if (k === 'zoned') scatter(4.6, 3.4, 0.6, function (x0, y0c) { dots += 'M' + n1(x0) + ',' + n1(y0c + (rnd() - 0.5) * 0.8) + 'h.01'; });

      /* airflow hairlines, only where Molecule says air moves */
      if (ease) {
        xs = cx((y0 + y1) / 2) + 1.4; span = X1 + OUT - xs;
        var len = 0.3 + 0.36 * ease, wide = 0.44 + 0.2 * ease, lines = yb - ya < 4 ? 1 : yb - ya >= 13 && ease > 0.3 ? 3 : 2;
        if (a && (k === 'zoned' || k === 'airtec-channel')) {
          /* one runs along the channels, behind the bumps, so it shows in the valleys */
          behind = streak(cx(y0) + 1, X1 + OUT, y0 + a * 0.5, 0, 0, Math.min(0.55, wide));
          lines = Math.max(1, lines - 1);
        }
        for (j = 0; j < lines; j++) {
          yy = ya + (j + 0.5) * (yb - ya) / lines; q = Math.min(0.75, (yb - ya) / lines * 0.2); t0 = rnd() * 6.283;
          var gap = 1 - len - 0.07, more = Math.min(gap, 0.3);
          if (j % 2 === 0) {
            front += streak(xs, xs + span * len, yy, q, t0, wide);
            if (more >= 0.16) front += streak(xs + span * (1 - more), xs + span, yy, q, t0, wide * 0.85);
          } else {
            if (more >= 0.16) front += streak(xs, xs + span * more, yy, q, t0, wide * 0.85);
            front += streak(xs + span * (1 - len), xs + span, yy, q, t0, wide);
          }
        }
      }

      o += '<g class="' + (l.lift ? 'c-lift ' : '') + 'm-l m-' + k + (ease ? ' m-air' : '') + '"' + (l.lift ? ' style="--lift:' + n1(l.lift) + '"' : '') + '>';
      if (behind) o += '<path class="m-flow" d="' + behind + '"/>';
      o += '<path class="m-fill" d="' + shape + '"/><path d="' + shape + '" fill="url(#' + id + 'g)"/>';
      o += extra;
      if (cells) o += '<path class="m-cell" d="' + cells + '"/>';
      if (dots) o += '<path class="m-dot" d="' + dots + '"/>';
      if (edge) o += '<path class="m-contour" d="' + edge + '"/>';
      if (front) o += '<path class="m-flow" d="' + front + '"/>';
      if (!last) o += '<path class="m-seam" d="M' + n1(cx(y1)) + ',' + n1(y1 - 0.2) + 'H' + X1 + '"/>';
      o += '</g>';
      y = y1;
    });

    /* the cover over the cut: a thin knit lid that lifts highest */
    var yl = top + COV;
    o += '<g class="c-lift m-l m-cover" style="--lift:' + n1(level * STEP + 4) + '">';
    o += '<path class="m-lid" d="M' + n1(cx(top)) + ',' + n1(top) + 'H' + (X1 - 1.6) + 'Q' + X1 + ',' + n1(top) + ' ' + X1 + ',' + n1(top + 1.6) + 'V' + n1(yl) + 'H' + n1(cx(yl)) + 'Z"/>';
    d = 'M' + n1(cx(top) + 2) + ',' + n1(top + 1);
    for (x = cx(top) + 2, r = 1; x < X1 - 4; x += 2.6, r = -r) d += 'Q' + n1(x + 1.3) + ',' + n1(top + 1 - r * 0.6) + ' ' + n1(x + 2.6) + ',' + n1(top + 1);
    o += '<path class="m-knit" d="' + d + '"/></g>';

    o += '<path class="m-cutline" d="M' + n1(cx(top)) + ',' + n1(top) + 'L' + n1(cx(FLOOR)) + ',' + FLOOR + '"/>';
    o += '<path class="c-floor" d="M2,' + (FLOOR + 0.6) + 'H' + (VW - 1) + '"/>';
    return '<svg class="m-fig m-fig--' + (reflex ? 'reflex' : 'core') + '" viewBox="0 0 ' + VW + ' ' + VH + '" aria-hidden="true" focusable="false">' + o + '</svg>';
  }

  /* the shared script does not catch: a drawing that fails must not take the row controls with it */
  draws.molecule = function (version, inches, kinds) {
    try { return draw(version, inches, kinds); } catch (err) { return ''; }
  };
})();
